module.exports = __webpack_public_path__ + "static/media/top-button-white.0f72afa0.svg";